import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { ANALYTICS_ADMISSION_OFFICE, GLOBAL_STATE } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const ANALYTICS = GLOBAL_STATE

const analyticsSlice = createSlice({
  name: ANALYTICS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.analyticsAdmissionOffice.pending, state => {
        state[ANALYTICS_ADMISSION_OFFICE].loading = true
      })
      .addCase(actionCreators.analyticsAdmissionOffice.rejected, (state, action) => {
        state[ANALYTICS_ADMISSION_OFFICE].loading = false
        state[ANALYTICS_ADMISSION_OFFICE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.analyticsAdmissionOffice.fulfilled, (state, action) => {
        state[ANALYTICS_ADMISSION_OFFICE].loading = false
        state[ANALYTICS_ADMISSION_OFFICE].error = null
        state[ANALYTICS_ADMISSION_OFFICE].data = action.payload
      })

    builder.addCase(actionCreators.analyticsAdmissionOfficeClear, state => {
      state[ANALYTICS_ADMISSION_OFFICE] = defaultState()
    })
  },
})

export const { reducer: analyticsReducer } = analyticsSlice
